import React, { useState, useEffect, useLayoutEffect } from 'react';
import {
    useLocation,
    useSearchParams
} from 'react-router-dom';
import { USER_TYPES } from '../../../utils/constants/user-types';
import UserTypes from './details/UserTypes';
import Suppliers from '../suppliers';

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Users = () => {
    const query = useQuery();
    const [searchParams, setSearchParams] = useSearchParams();
    const [userTypes, setUserTypes] = useState<any>('suppliers');
    const [userPageTitle, setUserPageTitle] = useState<any>('Suppliers');

    const onClickUserType = (value: any, name: any) => {
        setUserTypes(value)
        setUserPageTitle(name)
        searchParams.set('type', value)
        setSearchParams(searchParams)
    }

    useLayoutEffect(() => {
        if (query?.get('type') && query?.get('type') !== userTypes) {
            setUserTypes(query?.get('type') || undefined)
        }
    }, [query?.get('type')])

    return (
        <div>
            <div>
                <p className='page-title'>{userPageTitle}</p>
            </div>
            <div className='mt-7 mb-7'>
                <UserTypes
                    items={USER_TYPES || []}
                    activeButton={userTypes || 'Type'}
                    onClickType={onClickUserType}
                />
            </div>
            {userTypes === 'suppliers' && <Suppliers />}
        </div>
    )
}

export default Users;